import { type CanvasSpecifier, makePingMessage } from "../../api-types";
import { safeStringify } from "../../json";
import { type LoggerInterface } from "../../logger-types";

export * from "./PageStorageSubscribableBridge";
export * from "./pageLocalStorageClient";
export * from "./CollaborativePageStorageBridge";
export * from "./PageStorageBridge";
export * from "./PageStorageFactory";
export * from "./StorageClientRegistry";

// FIXME: This is basically duplicated across all the collab clients.
export interface RoomClient {
	addEventListener: (
		type: string,
		callback: (event: MessageEvent | ErrorEvent | CloseEvent) => void,
		options?: boolean | AddEventListenerOptions | undefined
	) => void;
	removeEventListener: (
		type: string,
		callback: (event: MessageEvent | ErrorEvent | CloseEvent) => void
	) => void;
	id: string;
	close: () => void;
	send: (message: string | ArrayBuffer | Blob | ArrayBufferView) => void;
}

export const getCacheKey = (canvasSpecifier: CanvasSpecifier) => {
	return `pageLocalStorageCollab:page-id:${canvasSpecifier.id}:${canvasSpecifier.pageId}`;
};

// FIXME: This is the encapsulated logic of the room heart beat that is used across all collab clients.
export class RoomHeartbeat {
	private inFlightPingIDs = new Set<string>();
	private _pingInterval?: ReturnType<typeof setInterval>;

	constructor(
		private client: RoomClient,
		private logger: LoggerInterface,
		private pingIntervalMs?: number
	) {}

	acknowledgedPong(uuid: string) {
		if (this.inFlightPingIDs.has(uuid)) {
			this.inFlightPingIDs.delete(uuid);
		} else {
			this.logger.debug("attempted to acknowledge a non-existent uuid from a pong", {
				unknownID: uuid,
				inFlightPingIDs: this.inFlightPingIDs,
			});
		}
	}

	start() {
		if (this.pingIntervalMs) {
			this._pingInterval = setInterval(() => {
				try {
					if (this.inFlightPingIDs.size != 0) {
						// This shouldn't happen if connections are healthy.
						this.logger.info("found unacknowledged pings upon acknowledge completion", {
							inFlightPingIDs: this.inFlightPingIDs,
						});
					}
					const ping = makePingMessage();
					this.inFlightPingIDs.add(ping.uuid);
					this.client.send(safeStringify(ping));
				} catch (error) {
					this.logger.error("ping request failed due to error", {
						error,
					});
				}
			}, this.pingIntervalMs);
		}
	}

	stop() {
		clearInterval(this._pingInterval);
	}
}
